/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  successfullyLoggedIn: 'Sie haben sich erfolgreich angemeldet!',
  failedToLogIn: 'Beim Einloggen ist etwas schief gegangen, bitte versuchen Sie es noch einmal.',
  successfullyLoggedOut: 'Sie sind erfolgreich abgemeldet worden!',
  failedToLogOut: 'Etwas ist beim Ausloggen schief gelaufen, bitte versuchen Sie es noch einmal.',
  successfullyRecoveredPassword: 'Ihr Passwort wurde erfolgreich wiederhergestellt! Prüfen Sie Ihre E-Mails für weitere Anweisungen.',
  failedToRecoverPassword: 'Bei der Wiederherstellung Ihres Passworts ist etwas schief gelaufen, bitte versuchen Sie es erneut.',
  invalidateSuccess: 'Cache wurde erfolgreich zurückgesetzt.',
  sessionExpired: 'Ihre Sitzung ist abgelaufen, bitte loggen Sie sich erneut ein.',
}
